export default "__VITE_ASSET__Dzg_cBME__"